import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/es.string.link.js";
import "core-js/modules/web.dom-collections.iterator.js";
import AzButton from '~/components/_next/atoms/AzButton.vue';
import { useGetDisplayOptionsClasses } from '~/composables/useGetDisplayOptionsClasses';
import useProductContent from '@/composables/useProductContent/useProductContent';
import BaseScrollContainer from '~/components/Layout/BaseScrollContainer.vue';
export default defineComponent({
  name: 'BlockStackableTabs',
  components: {
    AzButton: AzButton,
    BaseScrollContainer: BaseScrollContainer,
    RenderContent: function RenderContent() {
      return import('~/components/cms/page/RenderContent.vue');
    }
  },
  props: {
    tabs: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    topTitle: String,
    title: String,
    displayOptions: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  setup: function setup(props) {
    var _useProductContent = useProductContent(),
      mapComponentName = _useProductContent.mapComponentName;
    var currentActiveTabIndex = ref(0);
    var isContentExpanded = inject('isContentExpanded', false);
    var components = computed(function () {
      return mapComponentName(props.tabs);
    });
    var currentComponent = computed(function () {
      return components.value[currentActiveTabIndex.value];
    });
    var classes = useGetDisplayOptionsClasses(props.displayOptions);
    var setCurrentTab = function setCurrentTab(index) {
      currentActiveTabIndex.value = index;
    };
    var getTabLink = function getTabLink(tab) {
      var _tab$fields;
      return tab === null || tab === void 0 ? void 0 : (_tab$fields = tab.fields) === null || _tab$fields === void 0 ? void 0 : _tab$fields.link;
    };
    var getTabTitle = function getTabTitle(tab) {
      var _tab$fields2;
      return tab === null || tab === void 0 ? void 0 : (_tab$fields2 = tab.fields) === null || _tab$fields2 === void 0 ? void 0 : _tab$fields2.title;
    };
    return {
      components: components,
      setCurrentTab: setCurrentTab,
      currentActiveTabIndex: currentActiveTabIndex,
      currentComponent: currentComponent,
      isContentExpanded: isContentExpanded,
      classes: classes,
      getTabLink: getTabLink,
      getTabTitle: getTabTitle
    };
  }
});